export function moneyTry(n) {
  const x = Number(n || 0);
  return `${x.toLocaleString('tr-TR')} ₺`;
}

export function hm(min) {
  const m = Number(min || 0);
  const h = String(Math.floor(m / 60)).padStart(2, '0');
  const mm = String(m % 60).padStart(2, '0');
  return `${h}:${mm}`;
}

export function memberName(member) {
  return member?.fullName || `${member?.name || ''} ${member?.surname || ''}`.trim() || 'Üye';
}

export function statusLabel(status) {
  const s = String(status || '').toUpperCase();
  if (s === 'ATTENDED') return 'Katıldı';
  if (s === 'NO_SHOW') return 'Gelmedi';
  if (s === 'BURNED') return 'Yandı';
  if (s === 'CANCELLED') return 'İptal';
  if (s === 'PENDING') return 'Bekliyor';
  return s || '—';
}

export function statusIcon(status) {
  const s = String(status || '').toUpperCase();
  if (s === 'ATTENDED') return 'check_circle';
  if (s === 'NO_SHOW' || s === 'BURNED') return 'cancel';
  if (s === 'CANCELLED') return 'event_busy';
  if (s === 'PENDING') return 'hourglass_top';
  return 'help';
}

export function packageSortDate(items = []) {
  return items.reduce((acc, item) => {
    const key = `${item?.dayISO || ''} ${String(item?.startMin ?? 0).padStart(4, '0')}`;
    return key > acc ? key : acc;
  }, '');
}

export function buildPackageGroups(attendanceRows, timelineRows) {
  const groups = new Map();

  (Array.isArray(attendanceRows) ? attendanceRows : []).forEach((row) => {
    const key = row?.memberPlanId ? String(row.memberPlanId) : `no-plan:${row?.planName || '—'}`;
    if (!groups.has(key)) {
      groups.set(key, {
        key,
        memberPlanId: row?.memberPlanId ?? null,
        planName: row?.planName || 'Paket bağlantısı yok',
        total: row?.packageTotal ?? null,
        items: [],
      });
    }

    groups.get(key).items.push({
      kind: 'attendance',
      id: row?.attendanceId ?? `${row?.sessionId}-${row?.createdAt}`,
      sessionId: row?.sessionId ?? null,
      dayISO: row?.dayISO ?? null,
      startMin: row?.startMin ?? null,
      activityName: row?.activityName ?? null,
      trainerName: row?.trainerName ?? null,
      attendanceStatus: row?.attendanceStatus ?? null,
      markedBy: row?.markedBy || '—',
      usageIndex: row?.usageIndex ?? null,
      packageTotal: row?.packageTotal ?? null,
      paymentStatus: null,
      debtTry: 0,
    });
  });

  (Array.isArray(timelineRows) ? timelineRows : []).forEach((row) => {
    const key = row?.memberPlanId ? String(row.memberPlanId) : `no-plan:${row?.planName || '—'}`;
    if (!groups.has(key)) {
      groups.set(key, {
        key,
        memberPlanId: row?.memberPlanId ?? null,
        planName: row?.planName || 'Paket bağlantısı yok',
        total: row?.packageTotalSessions ?? null,
        items: [],
      });
    }

    const group = groups.get(key);
    if (group.total == null && row?.packageTotalSessions != null) {
      group.total = row.packageTotalSessions;
    }

    const exists = group.items.some((item) => String(item.sessionId) === String(row?.sessionId));
    if (!exists) {
      group.items.push({
        kind: 'timeline',
        id: row?.sessionParticipantId ?? row?.sessionId,
        sessionId: row?.sessionId ?? null,
        dayISO: row?.dayISO ?? null,
        startMin: row?.startMin ?? null,
        activityName: row?.activityName ?? null,
        trainerName: row?.trainerName ?? null,
        attendanceStatus: row?.attendanceStatus ?? null,
        markedBy: '—',
        usageIndex: row?.packageSessionOrdinal ?? row?.consumedCount ?? null,
        packageTotal: row?.packageTotalSessions ?? null,
        paymentStatus: row?.paymentStatus ?? null,
        debtTry: row?.debtTry ?? 0,
      });
    }
  });

  return Array.from(groups.values())
    .map((group) => {
      const items = group.items.slice().sort((a, b) => {
        const ad = String(a?.dayISO || '');
        const bd = String(b?.dayISO || '');
        if (ad !== bd) return ad.localeCompare(bd);
        return Number(a?.startMin || 0) - Number(b?.startMin || 0);
      });

      return {
        ...group,
        items,
        usedCount: items.filter((item) => item.kind === 'attendance').length,
        latestKey: packageSortDate(items),
      };
    })
    .sort((a, b) => String(b.latestKey || '').localeCompare(String(a.latestKey || '')));
}

export function buildMemberAnalysis(member, groups) {
  const allItems = (groups || []).flatMap((group) => group.items || []);
  const attended = allItems.filter(
    (item) => String(item?.attendanceStatus || '').toUpperCase() === 'ATTENDED'
  ).length;
  const noShow = allItems.filter(
    (item) => String(item?.attendanceStatus || '').toUpperCase() === 'NO_SHOW'
  ).length;
  const cancelled = allItems.filter(
    (item) => String(item?.attendanceStatus || '').toUpperCase() === 'CANCELLED'
  ).length;

  const trainers = Array.from(
    new Set(allItems.map((item) => item?.trainerName).filter((value) => value && value !== '—'))
  );

  return {
    memberName: memberName(member),
    packageCount: groups.length,
    attendanceCount: allItems.length,
    attended,
    noShow,
    cancelled,
    openDebtTry: Number(member?.debtTry || member?.balanceTry || 0),
    trainers,
    latestPackages: groups.slice(0, 2),
  };
}
